import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from '../actions';

const initialState = null;

function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return action.payload

    case LOGOUT_SUCCESS:
      return null;

    default:
      return state;
  }
}

export default reducer;
